/**
 * Do not edit directly
 * Generated on Fri, 04 Sep 2020 07:42:35 GMT
 */

export const SpinnerWidth = "24px"; // standard Spinner
export const SpinnerHeight = "24px";
export const SpinnerStrokeSize = "2px";
export const SpinnerSpeed = ".6s"; // 


export const SpinnerSmallWidth = "14px"; // small Spinner
export const SpinnerSmallHeight = "14px";
export const ScaleUpDuration = "0.3s";
export const BgColorNeutral100 = "#FFFFFF"; // Background Neutral Colors 
export const BgColorNeutral098 = "#FAFAFA";
export const BgColorNeutral096 = "#F5F5F5";
export const BgColorNeutral093 = "#EEEEEE";
export const BgColorNeutral080 = "#CDCDCD";
export const BgColorNeutral042 = "#6B6B6B";
export const BgColorNeutral024 = "#3D3D3D";
export const BgColorNeutral009 = "#161616"; // 


export const BgColorStatusBaseGo = "#188725"; //  Status Palette Colors 
export const BgColorStatusBaseWait = "#E26812";
export const BgColorStatusBaseStop = "#D42902";
export const BgColorStatusBaseHelp = "#416CAD";
export const BgColorStatusBaseLike = "#DB0BB7"; // 


export const BgColorPrimary = "#5744af"; // Brandable Background Color 
export const BorderRadius10 = "10px";
export const BorderRadius16 = "16px";
export const BorderRadius00 = "0"; // Border Radius
export const BorderRadius02 = "2px";
export const BorderRadius04 = "4px";
export const BorderRadius08 = "8px";
export const BorderRadiusCircle = "50%"; // 


export const BorderNeutral100Skinny = "#ffffff 1px solid"; // Border Neutral
export const BorderNeutral100Fat = "#ffffff 2px solid";
export const BorderNeutral096Skinny = "#f5f5f5 1px solid";
export const BorderNeutral096Fat = "#f5f5f5 2px solid";
export const BorderNeutral093Skinny = "#eeeeee 1px solid";
export const BorderNeutral093Fat = "#eeeeee 2px solid";
export const BorderNeutral080Skinny = "#cdcdcd 1px solid";
export const BorderNeutral080Fat = "#cdcdcd 2px solid";
export const BorderNeutral024Skinny = "#3d3d3d 1px solid";
export const BorderNeutral024Fat = "#3d3d3d 2px solid"; // 


export const BorderFocusConfigSkinny = "#305080 1px solid"; // Border Focus
export const BorderFocusConfigFat = "#305080 2px solid"; // 


export const BorderFocusConnectSkinny = "#ffb81c 1px solid"; // Border Focus
export const BorderFocusConnectFat = "#ffb81c 2px solid"; // 


export const BorderFocusDialogSkinny = "#327f86 1px solid"; // Border Focus
export const BorderFocusDialogFat = "#327f86 2px solid"; // 


export const BorderFocusSpotlightSkinny = "#55c1ff 1px solid"; // Border Focus
export const BorderFocusSpotlightFat = "#55c1ff 2px solid"; // 


export const BorderFocusBrandPrimarySkinny = "#5744af 1px solid"; // Border Focus
export const BorderFocusBrandPrimaryFat = "#5744af 2px solid"; // 


export const BorderStatusStopSkinny = "#d42902 1px solid"; // Border Status
export const BorderStatusStopFat = "#d42902 2px solid";
export const BorderStatusWaitSkinny = "#e26812 1px solid";
export const BorderStatusWaitFat = "#e26812 2px solid";
export const BorderStatusGoSkinny = "#188725 1px solid";
export const BorderStatusGoFat = "#188725 2px solid";
export const BorderStatusHelpSkinny = "#416cad 1px solid";
export const BorderStatusHelpFat = "#416cad 2px solid";
export const BorderStatusLikeSkinny = "#db0b87 1px solid";
export const BorderStatusLikeFat = "#db0b87 2px solid"; // 


export const ButtonStandardIconsize = "24px";
export const ButtonStandardP1PrimaryColor = "#3d3d3d"; // standard Primary Button
export const ButtonStandardP1PrimaryBackgroundColor = "#ffb81c";
export const ButtonStandardP1PrimaryBorderRadius = "4px"; // 


export const ButtonStandardP1PrimaryIconColor = "#3d3d3d"; // standard Primary Icon Button
export const ButtonStandardP1PrimaryIconBackgroundColor = "#ffb81c";
export const ButtonStandardP1PrimaryIconPressedBgcolor = "#eea83c";
export const ButtonStandardP1PrimaryIconIconsize = "24px";
export const ButtonStandardP1PrimaryIconBorderRadius = "4px"; // 


export const ButtonQuietIconsize = "24px"; // 


export const ButtonSmallP1PrimaryColor = "#ffb81c"; // mall Primary Button
export const ButtonSmallP1PrimaryBackgroundColor = "#fef5e3";
export const ButtonSmallP1PrimaryBorderRadius = "4px";
export const ButtonSmallP1PrimaryPressedFontcolor = "#3d3d3d";
export const ButtonSmallP1PrimaryPressedBgcolor = "#ffb81c"; // 


export const ButtonTextLinkSize = "1rem"; // 


export const ButtonTextLinkWeight = "400";
export const ButtonTextLinkLineHeight = "1.45";
export const ButtonTextLinkLetterSpacing = "normal"; // text link 


export const ColorConfigBase = "#305080"; // Config Colors
export const ColorConfig010 = "#305080";
export const ColorConfig020 = "#305080"; // 


export const ColorDialogBase = "#327f86"; // Dialog Colors
export const ColorDialog010 = "#327f86";
export const ColorDialog020 = "#327f86"; // 


export const ColorConnectBase = "#ffb81c"; // Connect Colors
export const ColorConnectDark = "#f59900";
export const ColorConnectLight = "#fdd47c";
export const ColorConnectXDark = "#ae6f0f";
export const ColorConnectXLight = "#fef5e3";
export const ColorConnectXXLight = "#4e2d13";
export const ColorConnect010 = "#ffb81c";
export const ColorConnect020 = "#ffb81c"; // 


export const ColorSpotlightBase = "#55c1ff"; // Spotlight Colors
export const ColorSpotlight010 = "#4fb8db";
export const ColorSpotlight020 = "#4fb8db"; // 


export const ColorDiscoverBase = "#785ddb"; // Disover Colors
export const ColorDiscover010 = "#785ddb";
export const ColorDiscover020 = "#785ddb"; // 


export const ColorVisionBase = "#7f2567"; // Vision Colors
export const ColorVision010 = "#7f2567";
export const ColorVision020 = "#7f2567"; // 


export const ColorBrandPrimary = "#5744af"; // Brandable Colors 
export const ColorBrandPrimary010 = "#5744af";
export const ColorBrandPrimary020 = "#5744af";
export const ColorBrandAtRisk = "#b888e2";
export const ColorBrandAtRisk010 = "#06b87f";
export const ColorBrandAtRisk020 = "#06b87f";
export const ColorBrandDue = "#fbc666";
export const ColorBrandDue010 = "#fbc666";
export const ColorBrandDue020 = "#fbc666";
export const ColorBrandUrgent = "#ea862c";
export const ColorBrandUrgent010 = "#ea862c";
export const ColorBrandUrgent020 = "#ea862c";
export const ColorBrandOverdue = "#b02100";
export const ColorBrandOverdue010 = "#b02100";
export const ColorBrandOverdue020 = "#b02100";
export const ColorBrandSuccess = "#0a855d";
export const ColorBrandSuccess010 = "#0a855d";
export const ColorBrandSuccess020 = "#0a855d"; // 


export const ColorPrimaryBase = "#ffb81c"; // Primary Colors
export const ColorPrimaryDark = "#eea83c";
export const ColorPrimaryLight = "#fdd47c";
export const ColorPrimaryXLight = "#fef5e3"; // 


export const ColorNeutral100 = "#ffffff"; //  Neutral Colors 
export const ColorNeutral098 = "#fafafa";
export const ColorNeutral096 = "#f5f5f5";
export const ColorNeutral093 = "#eeeeee";
export const ColorNeutral080 = "#cdcdcd";
export const ColorNeutral059 = "#979797";
export const ColorNeutral042 = "#6b6b6b";
export const ColorNeutral024 = "#3d3d3d";
export const ColorNeutral009 = "#161616"; // 


export const ColorStatusGoBase = "#188725"; // Color status go colors
export const ColorStatusGo010 = "#188725";
export const ColorStatusGo020 = "#188725"; // 


export const ColorStatusHelpBase = "#416cad"; // Color status help colors
export const ColorStatusHelp010 = "#416cad";
export const ColorStatusHelp020 = "#416cad"; // 


export const ColorStatusLikeBase = "#db0b87"; // Color status like colors
export const ColorStatusLike010 = "#db0b87";
export const ColorStatusLike020 = "#db0b87"; // 


export const ColorStatusStopBase = "#d42902"; // Color status stop colors
export const ColorStatusStop010 = "#d42902";
export const ColorStatusStop020 = "#d42902"; // 


export const ColorStatusWaitBase = "#e26812"; // Color status wait colors
export const ColorStatusWait010 = "#e26812";
export const ColorStatusWait020 = "#e26812"; // 


export const ColorFilterLight025 = "#ffffff";
export const ColorFilterLight007 = "#ffffff"; // Color Shades
export const ColorFilterLight080 = "#ffffff";
export const ColorFilterLight020 = "#ffffff";
export const ColorFilterDark020 = "#000000";
export const ColorFilterDark010 = "#000000";
export const ColorFilterDark005 = "#000000";
export const ColorFilterDark060 = "#000000";
export const ColorFilterDark002 = "#000000";
export const ColorFilterDark003 = "#000000"; // 


export const ColorFilterPrimaryBase10 = "#ffb81c";
export const ColorFilterPrimaryBase20 = "#ffb81c";
export const ExtraSmallBreakpoint = "0px"; // Breakpoints
export const ExtraSmallMaxWidth = "auto";
export const SmallBreakpoint = "(min-width: 576px)";
export const SmallMaxWidth = "540px";
export const MediumBreakpoint = "(min-width: 768px)";
export const MediumMaxWidth = "720px";
export const LargeBreakpoint = "(min-width: 992px)";
export const LargeMaxWidth = "960px";
export const ExtraLargeBreakpoint = "(min-width: 1200px)";
export const ExtraLargeMaxWidth = "1140px"; // 


export const GutterWidth = "32px"; // Grid Variables
export const GridColumns = 12; // 


export const Opacity25 = "0.25";
export const Opacity50 = "0.5"; // Opacity tokens
export const Opacity70 = "0.7";
export const Opacity75 = "0.75"; // 


export const Shadow12 = "0px 12px 10px 2px rgba(#aaaaaa, 0.12), 0px 5px 18px 4px rgba(#aaaaaa, 0.14), 0px 7px 5px 0px rgba(#aaaaaa, 0.2)";
export const Shadow24 = "0px 24px 38px 3px rgba(#aaaaaa, 0.12), 0px 9px 46px 8px rgba(#aaaaaa, 0.14), 0px 11px 15px 0px rgba(#aaaaaa, 0.2)";
export const Shadow02 = "0px 0px 4px 0px rgba(#aaaaaa, 0.12), 0px 3px 4px 0px rgba(#aaaaaa, 0.14), 0px 1px 5px 0px rgba(#aaaaaa, 0.2)"; // Box Shadows
export const Shadow06 = "0px 6px 10px 0px rgba(#aaaaaa, 0.12), 0px 1px 18px 0px rgba(#aaaaaa, 0.14), 0px 3px 5px 0px rgba(#aaaaaa, 0.2)";
export const ShadowCharm = "0 3px 5px 0 rgba(170, 170, 170, 0.2), 0 1px 18px 0 rgba(170, 170, 170, 0.14), 0 6px 10px 0 rgba(170, 170, 170, 0.12)";
export const ShadowInner = "inset 0px 1px 4px 0px rgba(#cdcdcd, 0.60)"; // 


export const ShadowDark12 = "0 7px 8px 0 #000000, 0 5px 22px 4px rgba(0, 0, 0, 0.14), 0 12px 17px 2px rgba(0, 0, 0, 0.12)";
export const ShadowDark24 = "0 11px 15px 0 #000000, 0 9px 46px 8px rgba(0, 0, 0, 0.12), 0 24px 38px 3px rgba(0, 0, 0, 0.12)";
export const ShadowDark02 = "0 1px 5px 0 #000000, 0 3px 4px 0 rgba(0, 0, 0, 0.14), 0 0 4px 0 rgba(0, 0, 0, 0.12)";
export const ShadowDark06 = "0 3px 5px 0 #000000, 0 1px 18px 0 rgba(0, 0, 0, 0.14), 0 6px 10px 0 rgba(0, 0, 0, 0.12)";
export const ShadowLight12 = "0 7px 8px 0 rgba(170, 170, 170, 0.2), 0 5px 22px 4px rgba(170, 170, 170, 0.14), 0 12px 17px 2px rgba(170, 170, 170, 0.12)";
export const ShadowLight24 = "0 11px 15px 0 rgba(170, 170, 170, 0.2), 0 9px 46px 8px rgba(170, 170, 170, 0.14), 0 24px 38px 3px rgba(170, 170, 170, 0.12)";
export const ShadowLight02 = "0 1px 5px 0 rgba(170, 170, 170, 0.2), 0 3px 4px 0 rgba(170, 170, 170, 0.14), 0 0 4px 0 rgba(170, 170, 170, 0.12)";
export const ShadowLight06 = "0 3px 5px 0 rgba(170, 170, 170, 0.2), 0 1px 18px 0 rgba(170, 170, 170, 0.14), 0 6px 10px 0 rgba(170, 170, 170, 0.12)";
export const Margin40 = "40px"; // 


export const MarginXxs = "2px"; // margin tokens
export const MarginXs = "4px";
export const MarginS = "8px";
export const MarginM1 = "16px";
export const MarginM2 = "24px";
export const MarginL = "32px";
export const MarginXl = "64px";
export const MarginXxl = "96px";
export const Padding40 = "40px"; // 


export const PaddingXxs = "2px"; // Padding tokens
export const PaddingXs = "4px";
export const PaddingS = "8px";
export const PaddingM1 = "16px";
export const PaddingM2 = "24px";
export const PaddingL = "32px";
export const PaddingXl = "64px";
export const PaddingXxl = "96px";
export const Spacing16 = "16px";
export const Spacing24 = "24px";
export const Spacing32 = "32px";
export const Spacing40 = "40px"; // 


export const Spacing64 = "64px";
export const Spacing96 = "96px";
export const Spacing02 = "2px"; // Spacing
export const Spacing04 = "4px";
export const Spacing08 = "8px";
export const FontFamilyBase = "'Lato', sans-serif"; // Font Family
export const FontFamilyLato = "'Lato', sans-serif"; // 


export const FontSize11 = "1rem * .73333"; // Font Sizes
export const FontSize12 = "1rem * 0.8";
export const FontSize13 = "1rem * 0.86666";
export const FontSize14 = "1rem * 0.933333";
export const FontSize15 = "1rem * 1";
export const FontSize20 = "1rem * 1.33333";
export const FontSize24 = "1rem * 1.5";
export const FontSize26 = "1rem * 1.73333";
export const FontSizeBase = "1rem"; // 


export const FontWeightThin = "100"; // Font Weight
export const FontWeightLight = "300";
export const FontWeightRegular = "400";
export const FontWeightMedium = "500";
export const FontWeightSemibold = "600";
export const FontWeightBold = "700";
export const FontWeightHeavy = "800";
export const FontWeightBlack = "900"; // 


export const FontLineHeight1 = "1.45"; // 


export const FontLineHeight2 = "1.6";
export const FontLineHeight3 = "1.23";
export const FontLineHeight4 = "1.14";
export const FontLineHeight5 = "1.71"; // Font Weight
export const FontLetterSpacingNormal = "normal"; // Letter spacing
export const FontLetterSpacing01 = "-0.1px";
export const FontLetterSpacing02 = "-0.2px";
export const FontLetterSpacing03 = "0.2px";
export const FontColorNeutral100 = "#ffffff";
export const FontColorNeutral024 = "#3d3d3d"; // Text Colors
export const FontColorNeutral042 = "#6b6b6b";
export const FontColorPrimary = "#ffb81c";
export const FontColorGo = "#188725";
export const FontColorWait = "#e26812";
export const FontColorStop = "#d42902";
export const FontColorHelp = "#416cad";
export const FontColorLike = "#db0b87";
export const FontColorDiscover = "#785ddb"; // 


export const ZindexTooltip = 1070; // Z-Index list
export const ZindexAlert = 1080;
export const ZindexMenu = 1060;
export const ZindexModal = 1050;
export const ZindexFixed = 1030;
export const ZindexSticky = 1020;
export const ZindexDropdown = 1000; // 

